import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { FaceButton, FaceButtonColor, FaceButtonSize } from '@common/toolbox';

import { DescriptionArea } from './DescriptionArea';

interface Props {
  disabled: boolean;
  showDivider: boolean;
  inquiry_path_message: string;
  isInApp: boolean;
  isZigzin: boolean;
  isNotParentShop: boolean;
  moveToShippingCSChat: () => void;
  moveToInquiryHistory: () => void;
  addQuestion: () => void;
}

export const Inquiry: React.FC<React.PropsWithChildren<Props>> = ({
  disabled = false,
  showDivider,
  inquiry_path_message,
  isInApp,
  isZigzin,
  isNotParentShop,
  moveToShippingCSChat,
  moveToInquiryHistory,
  addQuestion,
}) => {
  return (
    <>
      {isNotParentShop && (
        <InternalCsButton>
          <IcInquiry>&#x1F6CD;</IcInquiry>
          <Title>상품에 대해 궁금한 것이 있으신가요?</Title>
          <DescriptionArea
            isInApp={isInApp}
            inquiry_path_message={inquiry_path_message}
            disabled={disabled}
            addQuestion={addQuestion}
            moveToInquiryHistory={moveToInquiryHistory}
          />
        </InternalCsButton>
      )}
      {isZigzin && (
        <InternalCsButton>
          <IcInquiry>&#x1F69A;</IcInquiry>
          <Title>배송에 대해 궁금한 것이 있으신가요?</Title>
          <Description>
            직진배송의 배송 및 주문 후 문의(취소/환불 등)는 지그재그 고객센터에서 답변드립니다.
          </Description>
          <div>
            <FaceButton
              className='inquiry_button'
              disabled={disabled}
              onClick={moveToShippingCSChat}
              color_type={FaceButtonColor.GRAY900}
              size_type={FaceButtonSize.S15_H48}
              css={css`
                padding: 0 10px;
              `}
            >
              배송 채팅 상담하기
            </FaceButton>
          </div>
        </InternalCsButton>
      )}
      {showDivider && <TabDivider />}
    </>
  );
};

const InternalCsButton = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  margin: 0 0 20px;
  padding: 24px 16px;

  p {
    text-align: center;
  }

  > div {
    display: flex;
    justify-content: center;
    padding-top: 24px;
    width: 100%;

    .inquiry_button {
      position: relative;
      min-width: 200px;
    }
  }

  &::before {
    width: 100%;
    height: 1px;
    content: '';
    background: ${vars.v3Color.gray100};
    margin: 16px 0;
  }

  &:first-of-type {
    &::before {
      display: none;
    }
  }
`;

const IcInquiry = styled.div`
  position: relative;
  font-size: 40px;
  line-height: 48px;
  padding-top: 16px;
`;

const Title = styled.p`
  padding-top: 17px;
  font-size: 17px;
  font-weight: 800;
  color: ${vars.color.textStrong};
  letter-spacing: -0.3px;
  word-break: keep-all;

  @media (max-width: 374px) {
    width: 184px;
  }
`;

const Description = styled.p`
  width: 310px;
  padding-top: 12px;
  font-size: 13px;
  line-height: 15.6px;
  color: ${vars.color.textTertiary};
  word-break: keep-all;

  b {
    font-weight: 600;
    color: ${vars.color.textSecondary};
  }

  a {
    text-decoration: underline;
    color: ${vars.color.textSecondary};
  }
`;

const TabDivider = styled.div`
  border-top: 8px solid ${vars.v3Color.gray100};
`;
